import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const getPendingSettlements = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/admin/settlements/pending",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error fetching pending settlements:",
            error
        );

        toast.error(
            error?.response?.data?.message ||
            "خطا در دریافت درخواست‌های تسویه"
        );

        throw error;
    }
};

export const getSettlementHistory = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/admin/settlements/list",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Settlement history API error =>",
            error
        );

        throw error;
    }
};

export const uploadSettlementReceipt = async (
    accessToken,
    file
) => {
    try {
        const formData = new FormData();

        formData.append("file", file);

        const response = await axiosInstance.post(
            "/admin/settlements/upload-receipt",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error uploading settlement receipt:",
            error
        );

        toast.error(
            error?.response?.data?.message ||
            "خطا در بارگذاری رسید"
        );

        throw error;
    }
};

export const approveSettlement = async (
    accessToken,
    id,
    receiptImageUrl,
    paymentInfoText
) => {
    try {
        const response = await axiosInstance.post(
            `/admin/settlements/${id}/approve`,
            {
                receiptImageUrl,
                paymentInfoText,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error(
            "Error approving settlement:",
            error
        );

        toast.error(
            error?.response?.data?.message ||
            "خطا در تأیید درخواست تسویه"
        );

        throw error;
    }
};